const normalizeLabel = (value = '') => String(value).trim().toLowerCase()

export const normalizeTopicName = (topicName = '') => {
  const raw = String(topicName || '').trim()
  if (!raw) return ''
  return raw.includes('_') ? raw.split('_').slice(1).join('_').trim() : raw
}

export const buildIndicatorSelectionKey = (indicator = {}, topicList = []) => {
  const topicId = indicator.foreign_topic ?? ''
  return `${indicator.id ?? indicator.name}::${topicId}::${normalizeLabel(indicator.name || '')}`
}

export const buildIndicatorCardKey = (meta = {}) => {
  return [
    normalizeLabel(meta.area),
    normalizeLabel(meta.topic),
    normalizeLabel(meta.indicator),
    normalizeLabel(meta.frequency),
  ].join('::')
}

export const matchesIndicatorMeta = (indicator = {}, meta = {}, topicList = []) => {
  const indicatorName = normalizeLabel(indicator.name)
  const metaName = normalizeLabel(meta.indicator)
  if (!indicatorName || indicatorName !== metaName) return false

  const topicName = normalizeLabel(topicList.find(topic => topic.id === indicator.foreign_topic)?.name)
  const normalizedMetaTopic = normalizeLabel(meta.topic)
  const normalizedMetaTopicDisplay = normalizeLabel(normalizeTopicName(meta.topic))

  return (
    !topicName ||
    topicName === normalizedMetaTopic ||
    topicName === normalizedMetaTopicDisplay
  )
}
